import React from 'react'
import Browser from 'utils/Browser'

const BROWSER_NAME = Browser.name

/**
 * Display or not if module is active
 * @param {React.Component} supportBrowser
 * @param {['opera'|'chrome'|'safari'|'firefox'|'edge'|'edge-chromium']} browsers
 *
 * @returns {React.Component}
 */
function supportBrowser(WrappedComponent, browsers = []) {
  function Display(props) {

    if (!BROWSER_NAME) return null
    if (!browsers.includes(BROWSER_NAME)) return null

    return <WrappedComponent {...props} />
  }

  return Display
}

export default supportBrowser